import { buildPinnedItemRoute, getPinnedItemModuleLabel } from "../pins/pinnedItemRoutes";

export const RECENT_VIEWS_STORAGE_KEY = "recently-viewed.items.v1";
export const RECENT_VIEWS_UPDATED_EVENT = "recentViewsUpdated";
export const MAX_RECENT_VIEWS = 10;

const safeWindow = () => (typeof window !== "undefined" ? window : null);

const normalizeText = (value) => {
  const normalized = String(value || "").trim();
  return normalized || null;
};

const normalizeEntry = (entry) => {
  if (!entry || typeof entry !== "object") return null;
  const itemType = normalizeText(entry.itemType || entry.item_type);
  const itemId = normalizeText(entry.itemId || entry.item_id);
  const title = normalizeText(entry.title);
  if (!itemType || !itemId || !title) return null;
  const route = normalizeText(entry.route) || buildPinnedItemRoute(itemType, itemId);
  if (!route) return null;
  return {
    itemType,
    itemId,
    title,
    moduleLabel: normalizeText(entry.moduleLabel) || getPinnedItemModuleLabel(itemType),
    secondaryText: normalizeText(entry.secondaryText),
    route,
    viewedAt: normalizeText(entry.viewedAt || entry.viewed_at) || new Date().toISOString(),
  };
};

export const loadRecentViews = () => {
  const currentWindow = safeWindow();
  if (!currentWindow) return [];
  try {
    const raw = currentWindow.localStorage.getItem(RECENT_VIEWS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(normalizeEntry).filter(Boolean).slice(0, MAX_RECENT_VIEWS);
  } catch (_err) {
    return [];
  }
};

const saveRecentViews = (entries) => {
  const currentWindow = safeWindow();
  if (!currentWindow) return;
  try {
    currentWindow.localStorage.setItem(RECENT_VIEWS_STORAGE_KEY, JSON.stringify(entries));
  } catch (_err) {
    // ignore storage errors
  }
};

export const registerRecentView = (entry) => {
  const currentWindow = safeWindow();
  if (!currentWindow) return [];
  const normalized = normalizeEntry(entry);
  if (!normalized) return loadRecentViews();

  const next = [
    normalized,
    ...loadRecentViews().filter(
      (item) => !(item.itemType === normalized.itemType && item.itemId === normalized.itemId)
    ),
  ].slice(0, MAX_RECENT_VIEWS);

  saveRecentViews(next);
  currentWindow.dispatchEvent(
    new CustomEvent(RECENT_VIEWS_UPDATED_EVENT, {
      detail: normalized,
    })
  );
  return next;
};

